<div
  [ngClass]="[!isModal ? 'iu-specific-window-container' : '', 'iu-specific-window fast']"
  [attr.data-cy-specific-window-name]="name">
  <p-progressBar
    *ngIf="!isModal && isLoading"
    [mode]="'indeterminate'"
    [value]="0"
    [showValue]="false"
    [styleClass]="'loading-progressbar'"></p-progressBar>
  <p-scrollPanel [style]="{ width: '100%', height: '100%' }">
    <div id="page-wrap">
      <h1>{{ 'specificWindow.quickOrder.title' | translate }} ( {{ docStatus }} )</h1>
      <div id="customer">
        <div class="row">
          <table class="metaleft p-md-4 p-sm-12" id="meta" aria-label="metaleft table">
            <tr>
              <th class="meta-head" scope="row">{{ 'specificWindow.quickOrder.customer' | translate }}</th>
              <td class="p-grid"><ng-template #vcrBPartner></ng-template></td>
            </tr>
            <tr>
              <th class="meta-head" scope="row">{{ 'specificWindow.quickOrder.customerLocation' | translate }}</th>
              <td class="p-grid"><ng-template #vcrBPartnerLocation></ng-template></td>
            </tr>
            <tr>
              <th class="meta-head" scope="row">{{ 'specificWindow.quickOrder.deliveryViaRule' | translate }}</th>
              <td class="p-grid"><ng-template #vcrDeliveryViaRule></ng-template></td>
            </tr>
            <tr>
              <th class="meta-head" scope="row">{{ 'specificWindow.quickOrder.deliveryRule' | translate }}</th>
              <td class="p-grid"><ng-template #vcrDeliveryRule></ng-template></td>
            </tr>
          </table>

          <table class="metaright p-md-4 p-sm-12" id="meta" aria-label="metaright table">
            <tr>
              <th class="meta-head" scope="row">{{ 'specificWindow.quickOrder.order' | translate }}</th>
              <td class="p-grid"><ng-template #vcrOrder></ng-template></td>
            </tr>
            <tr>
              <th class="meta-head" scope="row">{{ 'specificWindow.quickOrder.poReference' | translate }}</th>
              <td class="p-grid"><ng-template #vcrPOReference></ng-template></td>
            </tr>
            <tr>
              <th class="meta-head" scope="row">{{ 'specificWindow.quickOrder.dateOrdered' | translate }}</th>
              <td class="p-grid"><ng-template #vcrDateOrdered></ng-template></td>
            </tr>
            <tr>
              <th class="meta-head" scope="row">{{ 'specificWindow.quickOrder.shipper' | translate }}</th>
              <td class="p-grid"><ng-template #vcrMShipper></ng-template></td>
            </tr>
          </table>
        </div>
        <a class="settings" (click)="isSidebarOpen = !isSidebarOpen">
          <i class="fas fa-cog" aria-hidden="true"></i>
        </a>
      </div>
      <table id="items" aria-label="items table">
        <thead>
          <tr>
            <th scope="col">{{ 'specificWindow.quickOrder.product' | translate }}</th>
            <th scope="col">{{ 'specificWindow.quickOrder.description' | translate }}</th>
            <!-- <th class="alignRight">{{ 'specificWindow.quickOrder.priceList' | translate }}</th> -->
            <th class="alignRight" scope="col">{{ 'specificWindow.quickOrder.unitPrice' | translate }}</th>
            <th scope="col">{{ 'specificWindow.quickOrder.quantity' | translate }}</th>
            <th scope="col">{{ 'specificWindow.quickOrder.discount' | translate }}</th>
            <th class="alignRight" scope="col">{{ 'specificWindow.quickOrder.totalLine' | translate }}</th>
            <th class="alignRight" scope="col"></th>
          </tr>
        </thead>
        <tbody>
          <ng-container *ngFor="let item of dataLines.length + 1 | fakeArray; let i = index">
            <tr [ngClass]="['item-row', i === dataLines.length ? 'hidden' : '']">
              <td class="item-name">
                <ng-template #vcrProduct></ng-template>
              </td>
              <td class="description"><ng-template #vcrDescription></ng-template></td>
              <!-- <td class="fastorder-price">
                <ng-template #vcrPriceList></ng-template>
              </td> -->
              <td class="fastorder-price">
                <div [hidden]="true">
                  <ng-template #vcrPriceList></ng-template> <ng-template #vcrPriceActual></ng-template>
                </div>

                <ng-template #vcrPriceEntered></ng-template>
              </td>
              <td class="fastorder-qty"><ng-template #vcrQty></ng-template></td>
              <td class="fastorder-discount"><ng-template #vcrDiscount></ng-template></td>
              <td class="fastorder-linetotal"><ng-template #vcrLineTotalAmt></ng-template></td>
              <td class="deleteButton">
                {{ item }}
                <button
                  *ngIf="i < $any(dataLines).length"
                  tooltipPosition="top"
                  showDelay="250"
                  [life]="3000"
                  [hideDelay]="250"
                  pTooltip="{{ 'generic.delete' | translate }}"
                  pButton
                  icon="icon-delete"
                  (click)="removeLine(dataLines[i], i)"
                  [disabled]="(dataStore?.data?.['DocStatus'] === 'CO' || dataStore?.data?.['DocStatus']?.id === 'CO')"></button>
              </td>
            </tr>
          </ng-container>
          <tr id="hiderow">
            <td colspan="7">
              <button
                pButton
                id="addrow"
                class="p-button p-button-secondary"
                title="Add a row"
                (click)="newLine()"
                [label]="'specificWindow.quickOrder.addrow' | translate"
                icon="icon-add"
                [disabled]="!dataStore?.data?.['C_Order_ID'] || (dataStore?.data?.['DocStatus'] === 'CO' || dataStore?.data?.['DocStatus']?.id === 'CO')"></button>
            </td>
          </tr>
        </tbody>
        <tfoot>
          <tr>
            <td colspan="4" class="blank"></td>
            <td class="total-line balance">
              <label>{{ 'specificWindow.quickOrder.orderTotal' | translate }}</label>
            </td>
            <td colspan="2" class="total-value balance fastorder-grandtotal">
              <ng-template #vcrGrandTotal></ng-template>
            </td>
          </tr>
          <tr>
            <td class="buttonExecute" colspan="7">
              <div>
                <button
                  pButton
                  *ngIf="
                    dataStore &&
                    dataStore.data['DocStatus'] &&
                    (dataStore.data['DocStatus'] !== 'DR' ||
                      (dataStore.data['DocStatus'].id && dataStore.data['DocStatus'].id !== 'DR'))
                  "
                  class="p-button p-button-warning"
                  (click)="$event.preventDefault(); $event.stopPropagation(); resetOrder()"
                  [label]="'specificWindow.quickOrder.newOrder' | translate"
                  icon="fa fa-plus"></button>
                <button
                  pButton
                  [disabled]="(dataStore?.data?.['DocStatus'] === 'CO' || dataStore?.data?.['DocStatus']?.id === 'CO')"
                  (click)="$event.preventDefault(); $event.stopPropagation(); processOrder()"
                  [label]="'specificWindow.processing' | translate"
                  [icon]="(dataStore?.data?.['DocStatus'] === 'CO' || dataStore?.data?.['DocStatus']?.id === 'CO') ? 'fa fa-ban' : 'fa fa-check'"
                  class="p-button p-button-success"></button>
              </div>
            </td>
          </tr>
        </tfoot>
      </table>
    </div>
    <div style="height: 70px"></div>
  </p-scrollPanel>
  <p-sidebar
    [(visible)]="isSidebarOpen"
    [baseZIndex]="6000"
    position="right"
    styleClass="p-sidebar-md fast-create-order">
    <div class="apiz-p-grid">
      <h1 class="iu-notification-center-title">
        {{ 'specificWindow.quickOrder.settings' | translate }}
      </h1>
      <ng-template #vcrSettings></ng-template>
    </div>
  </p-sidebar>
</div>
<ng-container *ngIf="displaySearch">
  <iu-modal-ui
    data-cy="search-panel"
    [attr.data-cy-columnName]="this.searchLinkedComponent.autoComplete.data.columnName"
    [title]="this.searchLinkedComponent.autoComplete.label"
    [hasCloseBtn]="true"
    (closeModalEmitter)="displaySearch = false">
    <div class="autocomplete-universal-filter">
      <iu-universal-filter-ui
        [tabId]="-1"
        [columns]="searchLinkedComponent.autoComplete.data.searchColumns"
        [gridTab]="gridTab"></iu-universal-filter-ui>
    </div>
    <iu-grid-tab-infinity-scroll-ui
      #gridTab
      (searchEmitter)="this.searchLinkedComponent.setSearchSelectItem($event); displaySearch = false"
      [data]="this.searchLinkedComponent.autoComplete.data"
      [container]="this"
      [isSearch]="true"
      [dataStored]="this.searchLinkedComponent.autoComplete.dataStored"></iu-grid-tab-infinity-scroll-ui>
  </iu-modal-ui>
</ng-container>
<div [ngClass]="[!displayFormUI ? 'hidden' : '', 'specificModal']">
  <iu-modal-ui
    [title]="specificWindowTitle"
    [isModalDisplay]="displayFormUI"
    (closeModalEmitter)="updateModalDisplay({ key: 'displayFormUI', value: false })">
    <ng-template #vcrSpecific></ng-template>
  </iu-modal-ui>
</div>
